import spartaSingletonUtility from '@sparta.global.utilities/sparta-singleton-utility/dist/es6.js';

/* eslint-disable import/no-unresolved */

/**
 * Utility calculator-math-utility
 * @description Math functions required for the credit-cards site calculators
 * @copyright 2017-12-19
 * @file
 */

// Utility implementation here.
// Utilities can export anything: singletons, classes, even pure functions.

/**
 * @name CalculatorMathUtility
 *
 * @class CalculatorMathUtility
 */
class CalculatorMathUtility {
  /**
   * Creates an instance of CalculatorMathUtility.
   * @memberof CalculatorMathUtility
   */
  constructor() {
    this.init();
  }

  /**
   * @name init
   * @description Runs on module init
   * @returns {Number} points
   * @memberof CalculatorMathUtility
   */
  init() {
    this.math = {
      /**
       * Get rewards
       * @param {Number} rewards rewards
       * @param {Number}times factor
       * @returns {Number} rewards
       */
      rewards(rewards, times) {
        return (Math.floor(rewards * times * 100) / 100).toFixed(2);
      },
      /**
       * Get percentages
       * @param {Number} rewards rewards
       * @param {Number} values values
       * @param {Number} times times
       * @returns {Number} percentages
       */
      percentages(rewards, values, times) {
        // deps
        const result = (Math.floor(rewards * times * 100) / 100 / values * 100).toFixed(3).slice(0, -1);
        if (!Number.isNaN(result)) {
          return result;
        }
        return 0;
      },
      /**
       * Get bargraph heights
       * @param {Number} rewards rewards
       * @param {Number} max max
       * @param {Number} times times
       * @returns {Number} bar graph height
       */
      barGraphHeight(rewards, max, times) {
        return Math.floor(rewards * times * 100) / 100 / max * 100;
      },
      /**
       * Get Travel percentage
       * @param {Number} values values
       * @param {Number} times times
       * @returns {Number} points
       */
      travel(values, times) {
        let points = 0;
        Object.keys(values).forEach(percentage => {
          points += parseInt(values[percentage] * percentage * times, 10);
        });
        return points;
      }
    };
  }
}

/**
 * @const calculatorMathUtility
 * @description single instance of CalculatorMathUtility used to expose this utility
 */
const calculatorMathUtility = spartaSingletonUtility('sparta.utility.calculatorMathUtility', CalculatorMathUtility);

export { calculatorMathUtility as default };
